import { render, staticRenderFns } from "./ToastHost.vue?vue&type=template&id=d0453ef6&scoped=true"
import script from "./ToastHost.vue?vue&type=script&lang=js"
export * from "./ToastHost.vue?vue&type=script&lang=js"
import style0 from "./ToastHost.vue?vue&type=style&index=0&id=d0453ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0453ef6",
  null
  
)

export default component.exports